'use client';

import { HERO_QUERYResult } from '@/_sanity';
import HeroBigBackgroundImage from './HeroBackgroundImage';
import Hero from './Hero';

const HeroDisplayer = ({ hero }: { hero: HERO_QUERYResult }) => {
  if (hero?.imageposition === 'background') {
    return <HeroBigBackgroundImage hero={hero} />;
  }

  return <Hero hero={hero} />;
};

export default HeroDisplayer;
